<app-larged-tuile
  icon="fa-kit fa-picto-pacwp"
  [title]="
    titles[actionStack!.getValue('wpPModeFonctionnementTemperature')]
      | translate
  "
  [buttons]="buttons"
  [status]="
    buttonMode[this.actionStack!.getValue('wpSEtatFonctionnementPAC')].title!
      | translate
  "
  [mode]="
    this.actionStack!.getValue('wpPTemperatureConsigne') === 0
      ? ''
      : getTemperature(
          this.actionStack!.getValue('wpPTemperatureConsigne') / 10,
          0
        )
  "
  [statusMode]="
    buttonMode[this.actionStack!.getValue('wpSEtatFonctionnementPAC')].status!
  "
  [selectItem]="this.actionStack!.getValue('wpCModeFonctionnement')"
  (onPressSetting)="this.openProductModal()"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PACWP_Controle,
      'wpCModeFonctionnement',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-larged-tuile>
